import {
  CARD_EXPIRATION_DATE_REGEX,
  getCardExpirationMonthIndex,
  getCurrentCardExpirationMonthIndex,
} from 'shared/utils/string/cardExpirationDate';
import { z } from 'zod';

export const expirationDateValidationMessages = {
  invalid: 'Enter a valid expiration date (MM/YY)',
  required: 'Required',
};

export const expirationDateSchema = z
  .string({ error: expirationDateValidationMessages.required })
  .min(1, { error: expirationDateValidationMessages.required })
  .length(5, { error: expirationDateValidationMessages.invalid })
  .superRefine((value, ctx) => {
    // Validate format (MM/YY)
    if (!CARD_EXPIRATION_DATE_REGEX.test(value)) {
      ctx.addIssue({
        code: 'custom',
        message: expirationDateValidationMessages.invalid,
      });
      return;
    }

    // Validate that the expiration date is not in the past
    const [month = 0, twoDigitYear = 0] = value.split('/').map(Number);
    const expirationMonthIndex = getCardExpirationMonthIndex(
      month,
      twoDigitYear,
    );

    if (expirationMonthIndex < getCurrentCardExpirationMonthIndex()) {
      ctx.addIssue({
        code: 'custom',
        message: expirationDateValidationMessages.invalid,
      });
    }
  });
